module.exports = __webpack_public_path__ + "img/PC_05.9d74c8b4.jpg";